export const debitCardContentBox = {
    showLockAndUnlockNavigation: false,
    showDisplayPinNavigation: false,
    showDisplayPanNavigation: false,
    showChangeCardLimitsNavigation: false,
};
